import {
  DEFAULT_PAGE_TITLE,
  useRouterPageTitle,
} from "@/hooks/use-router-page-title";
import { Helmet } from "react-helmet-async";

const formatRouterPageTitle = (title: string) =>
  title === DEFAULT_PAGE_TITLE
    ? DEFAULT_PAGE_TITLE
    : `${title} | ${DEFAULT_PAGE_TITLE}`;

/**
 * Updates page title with the title from `createPageRoute({ staticData: { title: string } })`.
 * Use BrowserPageTitle to customize the page title.
 */
export const RouterPageTitle = () => {
  const title = useRouterPageTitle();
  const pageTitle = formatRouterPageTitle(title);

  return (
    <Helmet>
      <title>{pageTitle}</title>
    </Helmet>
  );
};
